// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt20: FC<Receipt20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M8 14h6v-1.5H8V14Zm-2-3.25h8v-1.5H6v1.5ZM6 7.5h8V6H6v1.5ZM3 17V4.5c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44h11c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06V17H3Zm1.5-1.5h11v-11h-11v11Z" />
        </svg>
    );
};

export default Receipt20;
